export default __webpack_public_path__ + "static/media/100_19780.35a564e8.jpg";